/**
 * Auth0 SPA configuration — read z env vars, validates obecność.
 * `VITE_AUTH0_*` env vars musią być set per docs/ENVS.md §1.
 */

interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  redirectUri: string;
  scope: string;
  cacheLocation: 'memory' | 'localstorage';
  useRefreshTokens: boolean;
}

function readEnv(name: string): string {
  const value = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Missing env var ${name}. Skopiuj apps/web/.env.example do .env i wypełnij — patrz docs/ENVS.md §1.`,
    );
  }
  return value;
}

export function getAuth0Config(): Auth0Config {
  return {
    domain: readEnv('VITE_AUTH0_DOMAIN'),
    clientId: readEnv('VITE_AUTH0_CLIENT_ID'),
    audience: readEnv('VITE_AUTH0_AUDIENCE'),
    redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/callback` : '/callback',
    scope: 'openid profile email offline_access',
    // Memory cache + refresh token rotation = secure-by-default dla SPA.
    cacheLocation: 'memory',
    useRefreshTokens: true,
  };
}
